import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { ThemeContextProvider } from "./ThemeContext";
import App from "./App";
import Auth from "./components/Auth/Auth";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Servicios from "./pages/Servicios";
import NuevoServicio from "./pages/NuevoServicio";
import ServiciosPendientes from "./pages/ServiciosPendientes";
import reportWebVitals from "./reportWebVitals";
import * as ServiceWorkerRegistration from "./serviceWorkerRegistration";
import "./index.css";
import ServiciosImagenes from "./pages/ServiciosImagenes";
import VisorPdf from "./pages/VisorPdf";
import NuevaoOrdenDeTrabajo from "./pages/NuevaOrdenDeTrabajo";
import OrdebesDeTrabajo from "./pages/OrdenesDeTrabajo";
import CargarHoras from "./pages/CargarHoras";
import ReporteServicio from "./pages/ReporteServicio";
import NuevoReporteServicio from "./pages/NuevoReporteServicio";
import GestionUsuarios from "./pages/GestionUsuarios";
import ReporteHoras from "./pages/ReporteHoras";
import SetPassword from "./pages/SetPassword";
import PrimerAcceso from "./pages/PrimerAcceso";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <ThemeContextProvider>
      <BrowserRouter basename={"/"}>
        <Routes>
          <Route path="/Auth" element={<Auth />}>
            <Route path="Login" element={<Login />} />
          </Route>
          <Route path="/" element={<App />}>
            <Route path="" element={<Home />} />
            <Route path="Servicios" element={<Servicios />} />
            <Route path="NuevoServicio" element={<NuevoServicio />} />
            <Route path="servicios/imagenes/:idservicio" element={<ServiciosImagenes />} />
            <Route path="servicios/pdf/:idservicio" element={<VisorPdf />} />
            <Route path="crearOT" element={<NuevaoOrdenDeTrabajo />} />
            <Route path="ordenes" element={<OrdebesDeTrabajo />} />
            <Route path="cargar-horas" element={<CargarHoras />} />
            <Route path="ReporteServicio" element={<ReporteServicio />} />
            <Route path="NuevoReporteServicio" element={<NuevoReporteServicio />} />
            <Route path="Servicios-pendientes" element={<ServiciosPendientes />} />
          <Route path="gestion-usuarios" element={<GestionUsuarios />} />
          <Route path="reporte-horas" element={<ReporteHoras />} />
          </Route>
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/primer-acceso" element={<PrimerAcceso />} />
        </Routes>
      </BrowserRouter>
    </ThemeContextProvider>
  </StrictMode>
);
ServiceWorkerRegistration.register();
reportWebVitals();
